import moment from "moment";
import i18n from '@/plugins/i18n';

export default [

    {
        name: "stores",
        filterable: false,
        togglable: false
    },
    // {
    //     name: "title",
    //     filterable: false,
    //     togglable: false
    // },
    // {
    //     name: "create_date",
    //     width: "150px",
    //     filterable: false,
    //     togglable: true,
    // },
];



// WEBPACK FOOTER //
// ./src/components/central/account/stores/vuetable/FieldsDef.js